module.exports = __webpack_public_path__ + "static/media/register_mark.8eea4141.svg";